import { useEffect, useRef } from "react";
import { useWebsocket } from "./useWsConnection";

export function useAuctionSocket({ auctionId, onEvent, enabled = true }) {
  const { manager, registerRoomHandler, unregisterRoomHandler } = useWebsocket();
  const idRef = useRef(Symbol("auction-room-handler"));
  const callbackRef = useRef(onEvent);

  // Keep the latest callback reference.
  useEffect(() => {
    callbackRef.current = onEvent;
  }, [onEvent]);

  // Register room event handler.
  useEffect(() => {
    if (!enabled || !auctionId || !manager) return;

    registerRoomHandler(idRef.current, String(auctionId).trim(), (msg) => {
      callbackRef.current?.(msg);
    });

    return () => {
      unregisterRoomHandler(idRef.current);
    };
  }, [manager, auctionId, enabled, registerRoomHandler, unregisterRoomHandler]);

  // Join/leave room lifecycle.
  useEffect(() => {
    if (!enabled || !auctionId || !manager) return;

    manager.joinRoom(auctionId);

    return () => {
      manager.leaveRoom();
    };
  }, [manager, auctionId, enabled]);
}
